import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MenuService {

    menudata:any;
    constructor() { }

    menulist() {
        return this.menudata;
      }
      
}